import { render } from "./ContatoView.vue?vue&type=template&id=4e270ca9&lang=pug"
import script from "./ContatoView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoView.vue?vue&type=script&setup=true&lang=js"

import "./ContatoView.vue?vue&type=style&index=0&id=4e270ca9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__